class ExternalEmbedSettings {
  storageKey: string;

  constructor(storageKey: string) {
    this.storageKey = storageKey;
  }

  /**
   * Check if user has optted-in for displaying embedded content of current social site
   * localStorage data format example:
   * {
   *   'twitter': 1526385091696 // timestamp at which user opted-in
   * }
   * @param {String} site
   * @return {boolean}
   */
  userOpttedIn(site: string): boolean {
    const saveDuration = 1000 * 60 * 60 * 24 * 365; // 365 days
    const lowerCaseSite = site.toLowerCase();
    const ls = window.localStorage.getItem(this.storageKey);
    if (!ls) {
      // no localStorage item
      return false;
    } else {
      const userPref = JSON.parse(ls) as Record<string, number>;
      if (!userPref[lowerCaseSite]) {
        // no entry for current site
        return false;
      } else {
        // check if expired
        const opttedInTime = userPref[lowerCaseSite];
        if (Date.now() - opttedInTime >= saveDuration) {
          // expired, remove the item, update localStorage
          delete userPref[lowerCaseSite];
          window.localStorage.setItem(
            this.storageKey,
            JSON.stringify(userPref)
          );
          return false;
        } else {
          return true;
        }
      }
    }
  }

  optInUser(optIn: boolean, site?: string) {
    if (!site) return;

    const ls = window.localStorage.getItem(this.storageKey);
    const lowerCaseSite = site.toLowerCase();
    const userPref = ls ? JSON.parse(ls) as Record<string, number> : {};
    if (optIn) {
      userPref[lowerCaseSite] = Date.now();
    } else {
      delete userPref[lowerCaseSite];
    }
    window.localStorage.setItem(
      this.storageKey,
      JSON.stringify(userPref)
    );
  }
}

export {ExternalEmbedSettings};
